import { style } from "@vanilla-extract/css";

export const slidesContainerStyle = style({
  position: "relative",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  display: "grid",
  gridTemplateRows: "1fr",
  gridTemplateColumns: "1fr",
  selectors: {
    "&:empty": {
      display: "none",
    },
  },
});

export const slideStyle = style({
  gridRow: "1 / -1",
  gridColumn: "1 / -1",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  selectors: {
    "&:empty": {
      display: "none",
    },
  },
});

export const slideContentStyle = style({
  width: "100%",
  // minHeight: "100%",
  flex: 1,
  overflow: "hidden",
});
